import { Observable } from 'rxjs';
import { IS_MOBILE_TOKEN, USER_AGENT } from './const';
import { Provider } from '@angular/core';

// uglyhack for SSR and access window from first-level code
export function getWindow(): Window | undefined {
  return typeof window !== 'undefined' ? window : undefined;
}

// uglyhack for SSR and access document from first-level code
export function getDocument(): Document | undefined {
  return typeof document !== 'undefined' ? document : undefined;
}

export function getDeviceOrientation(): 'portrait' | 'landscape' {
  const window = getWindow();

  if (!window) {
    return 'landscape';
  }

  if (window.screen.orientation) {
    return window.screen.orientation.type.includes('landscape') ? 'landscape' : 'portrait';
  }

  // iOS/safari
  return Math.abs(+window.orientation) === 90 ? 'landscape' : 'portrait';
}

export function getDeviceWidth(): number {
  const document = getDocument();

  if (!document) {
    // treat as 720p notebook by default
    return 1360;
  }

  const deviceOrientation = getDeviceOrientation();

  return deviceOrientation === 'portrait'
    ? Math.max(document.documentElement!.clientWidth, window.innerWidth || 0)
    : Math.max(document.documentElement!.clientHeight, window.innerHeight || 0);
}

export function isTestingBrowser(): boolean {
  return USER_AGENT.ua.includes('SELENIUM');
}

export function logUat(...args: unknown[]): void {
  if (isTestingBrowser()) {
    console.warn('UAT: ', ...args);
  }
}

export const provideDeviceInfo = (isMobile$: Observable<boolean>): Provider[] => {
  return [{ provide: IS_MOBILE_TOKEN, useValue: isMobile$ }];
};
